import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'remitoNumero'
})
export class RemitoNumeroPipe implements PipeTransform {

  transform(value: number): string {
    if (value !== undefined && value !== null) {
      return value.toString().padStart(8, '0');
    } else {
      return "";
    }
  }
}
